import React, { useEffect } from 'react'
import { Picture } from 'react-responsive-picture';

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { Icon } from '@iconify/react'
import vueIcon from '@iconify/icons-logos/vue'
import sassIcon from '@iconify/icons-logos/sass'
import yarnIcon from '@iconify/icons-logos/yarn'
import webpackIcon from '@iconify/icons-logos/webpack'
import codepenIcon from '@iconify/icons-logos/codepen-icon'
import wordpressIcon from '@iconify/icons-logos/wordpress-icon'
import gruntIcon from '@iconify/icons-logos/grunt'
import bootstrapIcon from '@iconify/icons-logos/bootstrap';

import GsapIcon from '../assets/svg/gsap-omg.svg'

gsap.registerPlugin(ScrollTrigger);

export default () => {

  const projects = [
    {
      title: 'Portfolio Fany Righi',
      link: 'http://fanyrighi.netlify.app/',
      sources: [
        {
          media: '(max-width: 768px)',
          srcSet: 'https://res.cloudinary.com/dzxowa2ja/image/upload/c_scale,w_720/v1602437129/fanyrighi-optim_clmz2q.png',
        },
        {
          media: '(min-width: 769px)',
          srcSet: 'https://res.cloudinary.com/dzxowa2ja/image/upload/c_scale,w_432/v1602437129/fanyrighi-optim_clmz2q.png',
        },
      ],
      techno: [
        {
          el: <Icon icon={vueIcon} height={24} />,
          alt: 'Vue.js',
          link: 'https://vuejs.org/',
        },
        {
          el: <Icon icon={sassIcon} height={24} />,
          alt: 'SASS',
          link: 'https://sass-lang.com/',
        },
        {
          el: <Icon icon={yarnIcon} height={24} />,
          alt: 'Yarn',
          link: 'https://yarnpkg.com/',
        },
        {
          el: <Icon icon={webpackIcon} height={24} />,
          alt: 'Webpack',
          link: 'https://webpack.js.org/',
        },
      ],
    },
    {
      title: 'CodePen Animal Crossing',
      link: 'https://codepen.io/ScroogeMage/pen/zYvyKLb?editors=0110',
      sources: [
        {
          media: '(max-width: 768px)',
          srcSet: 'https://res.cloudinary.com/dzxowa2ja/image/upload/c_scale,w_720/v1602437128/acnh-codepen-optim_qhmylq.png',
        },
        {
          media: '(min-width: 769px)',
          srcSet: 'https://res.cloudinary.com/dzxowa2ja/image/upload/c_scale,w_432/v1602437128/acnh-codepen-optim_qhmylq.png',
        },
      ],
      techno: [
        {
          el: <Icon icon={codepenIcon} height={24} />,
          alt: 'Codepen',
          link: 'https://codepen.io/',
        },
        {
          el: <GsapIcon height={24} />,
          alt: 'GSAP',
          link: 'https://greensock.com/gsap/',
        },
      ],
    },
    {
      title: 'Webradio Radiokawa',
      link: 'https://www.radiokawa.com/',
      sources: [
        {
          media: '(max-width: 768px)',
          srcSet: 'https://res.cloudinary.com/dzxowa2ja/image/upload/c_scale,w_720/v1602437129/radiokawa-optim_urms6i.png',
        },
        {
          media: '(min-width: 769px)',
          srcSet: 'https://res.cloudinary.com/dzxowa2ja/image/upload/c_scale,w_432/v1602437129/radiokawa-optim_urms6i.png',
        },
      ],
      techno: [
        {
          el: <Icon icon={wordpressIcon} className="wordpress" height={24} />,
          alt: 'Wordpress',
          link: 'https://fr.wordpress.com/',
        },
        {
          el: <Icon icon={bootstrapIcon} height={24} />,
          alt: 'Bootstrap',
          link: 'https://getbootstrap.com/',
        },
        {
          el: <Icon icon={gruntIcon} height={24} />,
          alt: 'Grunt',
          link: 'https://gruntjs.com/',
        },
      ],
    },
  ]

  const RGBImages = (image) => {
    const colors = ["r", "g", "b"]
    const images = colors.map(color => {
      const img = image.cloneNode(true)

      img.classList.add(`vhs-filter__${color}`)

      return img
    })

    return images
  }

  useEffect(() => {
    const VHSify = (image) => {
      if (
        !CSS.supports("mix-blend-mode", "screen") ||
        !CSS.supports("filter", "url()")
      ) {
        return
      }
      const container = document.createElement("figure")
      const images = RGBImages(image)
  
      images.forEach(image => container.appendChild(image))
      container.classList.add("vhs-filter", "projects__thumb", "image", "is-16by9")
      image.replaceWith(container)
    }
  
    // Add VHS effect on images; disabled on hover
    document
      .querySelectorAll('.projects__imgLink > picture')
      .forEach(image => VHSify(image))

    gsap
    .timeline({
      scrollTrigger: {
        id: `projects`,
        trigger: '.projects',
        start: 'top bottom-=200',
        toggleActions: 'play none none none',
        markers: false,
      },
    })
    .fromTo('.projects__title, .projects__text, .projects__item', {
      autoAlpha: 0,
      y: 100,
    }, {
      autoAlpha: 1,
      y: 0,
      stagger: .2,
    })
  }, [])

  return (
    <div className="projects">
      <h2 className="projects__title title is-2">Projets</h2>
      <p className="projects__text content is-medium">Travaux professionnels, personnels et autres expérimentations !</p>
      <div className="level">
        {
          projects.map((proj, index) => (
            <div className="level-item projects__item" key={'proj-' + index}>
              <a target="_blank" rel="noreferrer" href={proj.link} className="projects__imgLink">
                <Picture
                  className="js-vhs-filter"
                  alt={`Miniature du projet ${proj.title}`}
                  sources={proj.sources} />
              </a>
              <div className="projects__details">
                <a target="_blank" rel="noreferrer" href={proj.link} className="projects__nameLink">
                  {`0${index + 1}. ${proj.title}`}
                </a>
                <div className="projects__techno level">
                  {
                    proj.techno.map((tech, index) => (
                      <div className="level-item projects__iconWrapper" key={'tech-' + index}>
                        <a target="_blank" rel="noreferrer" className="block projects__technoLink" href={tech.link} title={tech.alt}>
                          {tech.el}
                        </a>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
